<template>
  <div class="carStyle">
    <el-form :rules="rules" ref="form" :model="form">
      <div class="halfStyle">
        <div class="title">{{$t('VehicleManagement.baseInform')}}</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              prop="terminalId"
              :label="$t('common.terminalId')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.terminalId"
                autocomplete="off"
                class="terminalStyle"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item
              prop="firmwareVersion"
              :label="$t('TerminalFile.firmwareVersion')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.firmwareVersion"
                autocomplete="off"
                class="terminalStyle"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              prop="typeName"
              :label="$t('OTAManagement.typeIdStr')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.typeName"
                autocomplete="off"
                class="terminalStyle"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="simIccicd"
              :label="$t('TerminalFile.simIccicd')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.simIccicd"
                autocomplete="off"
                class="terminalStyle"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              prop="simNumber"
              :label="$t('VehicleManagement.simNumber')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.simNumber"
                autocomplete="off"
                class="terminalStyle"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="deliveryTime"
              :label="$t('VehicleManagement.deliveryTime')"
              :label-width="formLabelWidth"
            >
              <el-date-picker
                disabled
                value-format="yyyy-MM-dd"
                type="date"
                placeholder=""
                v-model="form.deliveryTime"
                class="terminalStyle"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ["bindTerminal"],
  data() {
    return {
      rules: {},
      form: {
        terminalId: "",
        firmwareVersion: "",
        typeName: "",
        simIccicd: "",
        simNumber: "",
        deliveryTime: "",
      },
      formLabelWidth: "70px",
    };
  },
  created() {
    
  },
  methods: {
    getSelectOneTerminal() {
      let param = {
        terminalId: this.bindTerminal,
      };
      this.$store
        .dispatch("VehicleStatus/GET_SELECTONETERMINAL", param)
        .then((res) => {
          if (res) {
            console.log(res);
            if (res.data.code == 200) {
              this.form = {
                terminalId: res.data.data.terminalId,
                firmwareVersion: res.data.data.firmwareVersion,
                typeName: res.data.data.typeName,
                simIccicd: res.data.data.simIccicd,
                simNumber: res.data.data.simNumber,
                deliveryTime: res.data.data.deliveryTime,
              };
            }
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>